import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { Env, readFromEnv } from "@cinch-nx/environments";
import axios from "axios";
import useSWR from "swr";
import laggy from "./middleware";
import { convertSearchFiltersToQueryParams } from "../../utils";
import { useCinchStores } from "../use-cinch-stores/use-cinch-stores";
var httpClient = axios.create();
var fetcher = function() {
    var _ref = _async_to_generator(function(url) {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        httpClient.get(url).then(function(res) {
                            return res.data;
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function fetcher(url) {
        return _ref.apply(this, arguments);
    };
}();
export function useSearchResults(params) {
    var searchApiUrl = readFromEnv(Env.SearchServiceUrl);
    var allCinchStoresLowercase = useCinchStores().allCinchStoresLowercase;
    var queryParams = convertSearchFiltersToQueryParams(params, allCinchStoresLowercase);
    var url = "".concat(searchApiUrl, "/vehicles").concat(queryParams.toString() ? "?".concat(queryParams) : "");
    return useSWR(url, fetcher, {
        use: [
            laggy
        ]
    });
}
